import { render, staticRenderFns } from "./OrderPrintDialog.vue?vue&type=template&id=2e22c61b&scoped=true"
import script from "./OrderPrintDialog.vue?vue&type=script&lang=js"
export * from "./OrderPrintDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderPrintDialog.vue?vue&type=style&index=0&id=2e22c61b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22c61b",
  null
  
)

export default component.exports